module.exports = __webpack_public_path__ + "img/blog-adobe-vs-magento-img-2.a8e1c18e.webp";